var _g;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#002EFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.5,
    d: "m11.977 15.5 5.37 23-1.045-.495-3.584-1.708L7.858 15.5zm8.762 0L23 25.703l-2.086 8.822L16.568 15.5h4.17zm-16.676 0 4.24 18.457-4.566-2.194L0 15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.571.5-8.804 39-3.176-1.548 4.525-20.058H.786L0 14.415h21.902l.785-3.479H2.743l2.744-3.478h17.985l.786-3.48H8.23L10.974.5H28.57zm2.98 3.441 2.735 3.504-6.337 28.385L24 37.78l7.551-33.84zm5.665 6.883L40 14.332 36.026 31.82 32 33.765z"
  }))));
});
const SvgCin7BlueLogo = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCin7BlueLogo);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGZpbGw9IiMwMDJFRkYiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0ibTExLjk3NyAxNS41IDUuMzcgMjMtMS4wNDUtLjQ5NS0zLjU4NC0xLjcwOEw3Ljg1OCAxNS41aDQuMTJ6bTguNzYyIDBMMjMgMjUuNzAzbC0yLjA4NiA4LjgyMkwxNi41NjggMTUuNWg0LjE3em0tMTYuNjc2IDAgNC4yNCAxOC40NTctNC41NjYtMi4xOTRMMCAxNS41aDQuMDYzeiIgZmlsbC1vcGFjaXR5PSIuNSIvPgogICAgICAgIDxwYXRoIGQ9Im0yOC41NzEuNS04LjgwNCAzOS0zLjE3Ni0xLjU0OCA0LjUyNS0yMC4wNThILjc4NkwwIDE0LjQxNWgyMS45MDJsLjc4NS0zLjQ3OUgyLjc0M2wyLjc0NC0zLjQ3OGgxNy45ODVsLjc4Ni0zLjQ4SDguMjNMMTAuOTc0LjVIMjguNTd6bTIuOTggMy40NDEgMi43MzUgMy41MDQtNi4zMzcgMjguMzg1TDI0IDM3Ljc4IDMxLjU1MSAzLjk0em01LjY2NSA2Ljg4M0w0MCAxNC4zMzIgMzYuMDI2IDMxLjgyIDMyIDMzLjc2NWw1LjIxNi0yMi45NDF6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";